module.exports = __webpack_public_path__ + "img/22_16.7a01af80.png";